/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { MatrixDependencies } from './dependenciesMatrixClass.generated';
import { createDenseMatrixClass } from '../../factoriesAny.js';
export var DenseMatrixDependencies = {
  MatrixDependencies: MatrixDependencies,
  createDenseMatrixClass: createDenseMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDenseMatrixClass.generated.js
// module id = 18
// module chunks = 0